/*
 * This is the main event handling pattern for these sites. All event handling is processed through event delegation
 * with the following pattern. Event handlers are defined but not bound to individual elements (decoupled) by calling 
 * Origin.onAction('someAction', function() { ... }); Elements are then tagged for specific events by adding a css 
 * class that starts with action- followed by the action name, so in our example above, the associated action would be
 * action-some-action. Multiple action handlers may be registered for a single action. If only one action handler should
 * be registered at a give time, you may setup that action by using Origin.singleOnAction(...) which will remove any 
 * existing action handlers for that action. This is useful if a script is loaded or included multiple times on a page 
 * (such as each time a details record is pagged).
 */
(function ($, obj) {
	if (arguments.length == 1) {
		obj = $;
	}

	var ACTION = {
		dataMap: {},
		handlers: {}
	};

	// Given an action, execute all of the action handlers in the context of the target element
	function handleAction(target, action, data, evt) {
		console.log('onAction:handleAction: ' + action);
		var act = action.toLowerCase();
		if (ACTION.handlers[act] && ACTION.handlers[act].length > 0) {
			var handlers = ACTION.handlers[act];

			// Has an actionData callback has been implemented to extract an elements data prior to event handling?
			var dataMap = ACTION.dataMap[ACTION.dataMap[act] ? act : '*'];
			data = $.extend(true, {}, dataMap.call(target, { type: action, target: target }, data), data || {});

			// Iterate over the action handlers and execute each one.
			for (var i = 0, il = handlers.length; i < il; i++) {
				if (handlers[i] !== null) {
					var settings = handlers[i][0];
					var ret = handlers[i][1].call(target, settings, { type: action, target: target, event: evt }, $.extend(true, {}, settings.data, data));
					// This handler is only executed once
					if (settings.one === true) {
						handlers[i] = null;
					}
					if (ret === false) {
						break;
					}
				}
			}
			// Trigger a jquery custom event for an additional point of integration
			//$( target.nodeType && target.nodeType == 1 ? target : document ).trigger('action' + act, [{ type: action, target: target }, data]);
		}
	}

	$.extend(obj, {
		actionCssClass: function (klass) {
			return klass.replace(/([a-z])([A-Z])/g, '$1-$2')
						.replace(/([a-z])([0-9])/gi, '$1-$2')
						.replace(/([0-9])([a-z])/g, '$1-$2')
						.toLowerCase();
		},
		actionData: function (action, handler) {
			var actions = action.split(/\s+/);
			for (var i = 0, il = actions.length; i < il; i++) {
				action = actions[i].toLowerCase();
				ACTION.dataMap[action] = handler;
			}
		},
		onAction: function (action, callback, data) {
			var settings = {
				unique: false,
				one: false,
				action: '',
				handler: null,
				data: null
			};
			if (arguments.length == 1) {
				settings = $.extend(settings, arguments[0]);
			} else if (arguments.length >= 2) {
				settings.action = action;
				settings.handler = callback;
				settings.data = data;
			}
			var actions = settings.action.split(/\s+/);
			for (var i = 0, il = actions.length; i < il; i++) {
				settings.action = actions[i];
				settings.actionClass = this.actionCssClass(settings.action);

				var action = settings.action.toLowerCase();
				if (!ACTION.handlers[action] || settings.unique === true) {
					ACTION.handlers[action] = [];
				}
				ACTION.handlers[action].push([settings, function (settings, evt, data) {
					return settings.handler.call(evt.target, evt, data);
				} ]);
			}
		},
		singleOnAction: function (action, callback, data) {
			this.onAction({
				action: action,
				handler: callback,
				data: data,
				unique: true
			});
		},
		doAction: function (action, data, target) {
			handleAction(target || document, action, data, null);
		}
	});

	// Our default datamap handler
	obj.actionData('*', function (evt, data) {
		if (typeof data != 'object') {
			if (this.nodeType && this.nodeType == 1) {
				return $(this).dataset();
			} else {
				return {};
			}
		}
		return data;
	});

	$.fn.doAction = function (action, data) {
		return this.each(function () {
			handleAction(this, action, data, null);
		});
	};


	// Handle capturing focus events
	if (document.addEventListener) {
		// Capture the focus event in the capture phase
		document.addEventListener('focus', function (evt) {
			if ($(evt.target).is(':text,select') && !$(evt.target).data('onactionbound')) {
				$(evt.target)
					.data('onactionbound', true)
					.bind('focus', function (evt) {
						// We're triggering a focusin event which is an IE specific event
						// but we're not IE here
					    $(document).trigger('onaction-focusin', [this]);
					});
			}
		}, true);
	}

	$(document)
		.bind('onaction-focusin', function (evt, _target) {
			var target = _target || evt.target;

			// Bind to change event for SELECT elements and synthetically bubble it
			if ($(target).is('select') && $(target).data('onactionchange') !== true) {
				console.log('onAction:binding change');
				$(target)
					.data('onactionchange', true)
					.change(function () {
						console.log('change event triggered');
						$(this).trigger('actionchange', [evt]);
					});
			}
		})
		.bind(Ios_Click + ' actionchange', function (evt) {
			var ret = true;

			if (evt.type == 'click' && ($(evt.target).is('select') || $(evt.target).is('option'))) {
				return;
			}

			if ($(evt.target).hasClass('disabled')) //in case the element is disabled
				return;

			//if the click is from a shape layer on map, ignore it here and let ADC api handle it.
			if ($(evt.target).html().indexOf('OpenLayers.Geometry.') > 0)
				return;

			// Construct a group of elements (target, parents) and walk 
			// through the elements looking for the first action-* class
			$($(evt.target).add($(evt.target).parents()).get().reverse())
				.each(function () {
					if (this.className && this.className.match) {
						var action = this.className.match(/(^|\s)action-([^\s]+)(\s|$)/);
						if (action) {
							action = action[2].replace(/[^a-z0-9]/gi, '').toLowerCase();
							console.log('onAction:actionCaptured: (' + evt.type + ')' + action + ' ' + this.tagName.toLowerCase() + '#' + ($(this).attr('id') || '') + '');
							handleAction(this, action, $(this).dataset(), evt);
							ret = false;
							return false;
						}
					}
				});

			// Do not cancel click events on a checkbox or radio button
			if (!$(evt.target).is(':checkbox,:radio,select')) {
				console.log('Returning ' + ret);
				if (ret == false) {
					evt.preventDefault();
				}
				return ret;
			}
		});
})(jQuery, Origin);